module.exports = __webpack_public_path__ + "static/media/Lykke03.c8c38890.jpg";